import { onCLS, onFID, onLCP, onFCP, onINP, onTTFB } from "web-vitals";
const { Trace, TRACE_DATA_TYPE_ENUM } = require(".");

/**
 * 性能指标埋点
 * @param {import('web-vitals').Metric} metric
 */
function sendToAnalytics(metric = {}) {
  try {
    // console.log("metric: ", metric);
    // Replace with whatever serialization method you prefer.
    // Note: JSON.stringify will likely include more data than you need.
    // const body = JSON.stringify(metric);
    // console.log('body: ', body);

    // Use `navigator.sendBeacon()` if available, falling back to `fetch()`.
    // (navigator.sendBeacon && navigator.sendBeacon("/analytics", body)) ||
    //   fetch("/analytics", { body, method: "POST", keepalive: true });
    const { name, value, delta, rating, navigationType } = metric;

    Trace(
      { name, value, delta, rating, navigationType },
      TRACE_DATA_TYPE_ENUM.performance
    );
  } catch (error) {
    console.log("error: ", error);
  }
}

try {
  onCLS(sendToAnalytics); // Cumulative Layout Shift
  onFID(sendToAnalytics); // First Input Delay
  onLCP(sendToAnalytics); // Largest Contentful Paint
  onFCP(sendToAnalytics); // First Contentful Paint
  onINP(sendToAnalytics); // Interaction to Next Paint
  onTTFB(sendToAnalytics); // time to first byte
} catch (error) {
  console.log("error: ", error);
}
